import React from "react";
import { Link } from "rebass";
import uuid from "uuid";
import {
  Text,
  SectionHeading,
  DisplayHeading,
  ExtraInfoHeading,
  RatioImage,
  FullWrapper,
  List,
  Box,
  Flex
} from "../components/Primitives";
import { ScrollPage } from "../components/ScrollPage";
import { getRatio16to9 } from "../utils/getRatio16to9";

const DesctiptionItem = ({ title, text, color, textAlign, ...props }) => {
  let TextItem = (
    <Text color="white" width={1} lineHeight={2} textAlign={textAlign}>
      {text}
    </Text>
  );
  if (Array.isArray(text)) {
    TextItem = <List items={text} />;
  }
  return (
    <Box width={1} {...props}>
      <SectionHeading textAlign={textAlign} color={color}>
        {title}
      </SectionHeading>
      {TextItem}
    </Box>
  );
};

const ProjectBrief = ({
  title,
  color,
  description,
  technologies,
  position,
  ...props
}) => {
  return (
    <Box pb="5" px={[1, 0]} {...props}>
      <DisplayHeading textAlign="center" color={color} pb={5}>
        {title}
      </DisplayHeading>
      <Flex flexDirection={["column", "row"]} flexWrap={["wrap"]}>
        <DesctiptionItem
          width={[1, 1, 1 / 2]}
          title="the project"
          color={color}
          text={description}
          pb={[3, 3, 0]}
        />
        <Box width={[1, 1 / 2, 1 / 4]}>
          <DesctiptionItem
            width={1}
            color={color}
            title="position"
            text={position}
            pb={["3"]}
          />
          <DesctiptionItem
            width={1}
            color={color}
            title="the project"
            text="Lorem ipsum dolor sit amet"
            pb={[3, 0]}
          />
        </Box>
        <DesctiptionItem
          width={[1, 1 / 2, 1 / 4]}
          color={color}
          title="technologies"
          text={technologies}
        />
      </Flex>
    </Box>
  );
};
//Images span full image width ignoring content padding
const FeatureImage = ({ left, right, ...props }) => (
  <RatioImage
    {...props}
    ratio={9 / 16}
    width={[1, 1 / 2]}
    mr={[0, left ? 2 : 0]}
    ml={[0, right ? 2 : 0]}
    mb={[4, 0]}
    bg="accentBlue"
  />
);
const FeatureImageTag = ({ ...props }) => (
  <ExtraInfoHeading
    pl={[2, 4]}
    css={{
      position: "absolute",
      bottom: "100%",
      left: "0"
    }}
    {...props}
  />
);
const FeatureShowcase = ({
  title,
  link,
  imageLeft,
  imageRight,
  color,
  ...props
}) => {
  const linkToCode = link ? (
    <Link href={link} css={{ textTransform: "uppercase" }}>
      Code
    </Link>
  ) : (
    <Text
      pl={[0, 1]}
      width={"auto"}
      fontSize="0"
      css={{ display: "inline-block" }}
      color="inactive"
    >
      Code not available
    </Text>
  );
  return (
    <Box {...props}>
      <SectionHeading color={color} pb={[2, 5]}>
        {title} {linkToCode}
      </SectionHeading>
      <Flex flexDirection={["column", "row"]}>
        <FeatureImage left src={imageLeft.src} alt={imageLeft.alt}>
          <FeatureImageTag>Simple</FeatureImageTag>
        </FeatureImage>
        <FeatureImage right src={imageRight.src} alt={imageRight.alt}>
          <FeatureImageTag>Final</FeatureImageTag>
        </FeatureImage>
      </Flex>
    </Box>
  );
};
const Gallery = ({ images, ...props }) => (
  <Flex flexWrap="wrap" {...props}>
    {images.map(image => (
      <RatioImage
        ratio={[9 / 16]}
        width={[1, 1, 1 / 2]}
        mb="2"
        bg="accentBlue"
        src={image.src}
        alt={image.alt}
        key={uuid()}
      />
    ))}
  </Flex>
);
export const ProjectPage = ({
  color,
  title,
  description,
  technologies,
  position,
  features,
  gallery,
  cover,
  ...props
}) => {
  const projectData = { color, title, description, technologies, position };
  // Calculate the vh to rest from 100vw
  // Yes, my desings are stupid confusing

  const firstRatio = getRatio16to9(100);
  const secondRatio = getRatio16to9(firstRatio);
  const spaceX = getRatio16to9(secondRatio);
  const maxWidth = `calc(${100}vw - ${spaceX * 2}vh)`;
  return (
    <ScrollPage>
      {
        <>
          <FullWrapper
            flexDirection="column"
            maxWidth={["100%", "100%", "100%", maxWidth, "1280px"]}
            height={["auto", "100%"]}
            width={1}
            mx={["0", "0", "auto"]}
            my={[4, 0]}
          >
            <RatioImage
              ratio={[1, 9 / 16]}
              bg="accentBlue"
              src={cover.src}
              alt={cover.alt}
            />
          </FullWrapper>
          <Flex
            flexDirection="column"
            width={1}
            maxWidth={["100%", "100%", "100%", maxWidth, "1280px"]}
            px={[2, 2, 0]}
            mx={["none", "auto"]}
            mt={[0, "-96px", "-80px", 2, 2, "-40px"]}
            pb={4}
          >
            <ProjectBrief {...projectData} px={[2, 4]} />
            {features.map(data => (
              <FeatureShowcase
                {...data}
                color={color}
                px={[2, 4]}
                pb={5}
                key={uuid()}
              />
            ))}
            <Gallery images={gallery} px={[2, 4]} />
          </Flex>
        </>
      }
    </ScrollPage>
  );
};
ProjectPage.defaultProps = {
  title: "designing the code",
  description:
    "Lorem ipsum dolor sit amet. t Phasellus eget elit tellus. Curabitur dictum felis eget turpis bibendum sagittis. Praesent tempor bibendum diam sit amet blandit. Curabitur scelerisque rutrum pharetra. Morbi sodales dictum ante non dictum. Phasellus pretium venenatis nulla.",
  position: "front end developer",
  technologies: ["react", "styled components", "rebass"],
  color: "accentBlue",
  gallery: ["", "", "", ""],
  features: []
};
export default ProjectPage;
